import * as React from "react";
import type { SVGProps } from "react";
const SvgBusFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 17h1c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1M16 17h-1c-.55 0-1-.45-1-1s.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.99 20h-6v.49c0 .83-.68 1.51-1.51 1.51H6.5c-.83 0-1.51-.68-1.51-1.51V20A1.003 1.003 0 0 1 4 19V7c-.55 0-1 .45-1 1v3c0 .55-.45 1-1 1s-1-.45-1-1V8c0-1.65 1.35-3 3-3h.126A4 4 0 0 1 8 2h8a4 4 0 0 1 3.874 3H20c1.65 0 3 1.35 3 3v3c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55-.45-1-1-1v4.917q.008.09 0 .178V19c0 .55-.45 1-1 1h-.01v.49c0 .83-.68 1.51-1.51 1.51h-.98c-.83 0-1.51-.68-1.51-1.51zM18 7v4.262c-1.434.407-3.18.756-5.99.748-2.754-.009-4.55-.348-6.01-.754V7zm-.27-2H6.27c.347-.597.994-1 1.73-1h8c.736 0 1.383.403 1.73 1m-5.62 9c2.666 0 4.438-.294 5.89-.668V18H6v-4.679c1.499.376 3.342.671 6 .679z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusFront;
